import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import './Login.scss'
import { CContainer, CImage, CRow } from '@coreui/react-pro'
import Button from 'src/components/common/Button/Button'
import InputField from 'src/components/common/InputField/InputField'
import AIlogo from '../../../assets/Logo-AI.png'
import Logo from '../../../assets/Logo-White.svg'
import { login } from 'src/redux/user/userThunk'
import { useNavigate } from 'react-router-dom'
import Loader from 'src/components/common/Loader/Loader'
import PasswordField from 'src/components/common/PasswordField/PasswordField'
import { getIsAi } from '../../../utils/sharedFeaturesFunctions'
import { userLogout } from '../../../redux/user/userSlice'
import { toast } from 'react-toastify'

export default function Login() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [username, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [invalidUsername, setInvalidUsername] = useState(false)
  const [invalidPassword, setInvalidPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [error, setError] = useState(null)
  const isAI = getIsAi()

  const isDisabled = invalidUsername || invalidPassword

  useEffect(() => {
    dispatch(userLogout())
  }, [dispatch])

  const onKeyDown = (e) => {
    if (e.key?.toLowerCase() === 'enter' && !isDisabled) {
      onUserLogin()
    }
  }

  const onUsernameChange = (email) => {
    setIsSubmitted(false)
    setError(null)
    setEmail(email)
    setInvalidUsername(email.length <= 2)
  }

  const onPasswordChange = (password) => {
    setIsSubmitted(false)
    setError(null)
    setPassword(password)
    setInvalidPassword(password.length < 7)
  }

  const onUserLogin = async () => {
    onUsernameChange(username)
    onPasswordChange(password)
    if (username.length > 2 && password.length >= 7) {
      setIsSubmitted(true)
      setIsLoading(true)
      const result = await dispatch(login({ username, password }))
      setIsLoading(false)
      if (result?.payload?.data?.message) {
        if (result.payload.data.message.indexOf('expired') !== -1) {
          toast.info('Password expired. Please reset your password to login.')
          navigate('/resetPassword/userName')
        }
        return setError(result.payload.data.message)
      } else {
        setError(null)
      }

      if (result?.payload?.access_token) {
        navigate('/selectPractice')
      } else if (result?.payload?.mfa_token) {
        navigate('/MFALogin')
      } else if (!result?.payload?.status) {
        console.error('Error from server', result?.payload || result)
      }
    }
  }

  return (
    <div className="login-page container">
      {isLoading && <Loader />}
      <CContainer
        className="login-page-content"
        style={{ fontFamily: isAI ? 'Quicksand-Variable' : '' }}
      >
        <CRow className="mb-2 justify-content-center">
          {isAI && <CImage src={AIlogo} alt="Claimocity Logo" className="ai-logo" />}
          {!isAI && <CImage src={Logo} alt="Claimocity Logo" className="claimo-logo" />}
        </CRow>
        {isAI && <CRow className="claimo-title">Accelerate your day with Claimocity.</CRow>}
        {!isAI && <CRow className="claimo-title">Simplify your day with Claimocity.</CRow>}
        <div className=" mb-2 ">
          <InputField
            errormessage="Please enter a valid username"
            invalid={invalidUsername}
            label="Username"
            onChange={(e) => onUsernameChange(e.target?.value)}
            onKeyDown={onKeyDown}
            type="text"
            value={username}
          />
        </div>

        <PasswordField
          invalidPassword={invalidPassword}
          onPasswordChange={onPasswordChange}
          password={password}
          errormessage={'Please enter a valid password'}
          onKeyDown={onKeyDown}
        />

        {isSubmitted && error && <span className="error-message">{error}</span>}
        <div className="mt-3 mb-4 login-button">
          <Button
            id="login"
            fullWidth
            color="primary"
            onClick={onUserLogin}
            disabled={isDisabled}
            style={{
              fontFamily: 'Quicksand-Regular',
              fontSize: '18px',
              background: isAI ? 'var(--ai-gradient-horizontal)' : '',
              backgroundOrigin: isAI ? 'border-box' : '',
            }}
          >
            Log In
          </Button>
        </div>
        <CRow className=" mb-3">
          <Button
            fullWidth
            color="tertiary"
            compressed
            onClick={() => navigate('/resetPassword/userName')}
            style={{ fontFamily: isAI ? 'Quicksand-Variable' : '' }}
          >
            Forgot password
          </Button>
        </CRow>
        <CRow className=" mb-3">
          <a
            href={'https://status.claimocity.io/'}
            style={{ color: 'inherit', textDecoration: 'none', textAlign: 'center' }}
          >
            <b>System Status</b>
          </a>
        </CRow>
        <CRow className="version_no">
          <small>
            © {new Date().getFullYear()} Claimocity, Inc. All Rights Reserved. v
            {process.env.REACT_APP_VERSION}
          </small>
        </CRow>
      </CContainer>
    </div>
  )
}
